import { Capacitor } from "@capacitor/core";

const isMobile = Capacitor.getPlatform() !== 'web';

// NOTE: services append their own `/api/...` prefix (e.g. `${backendUrl}/api/herds`),
// so backendUrl must NOT include `/api` (prod uses '' and mobile uses the bare host).
const CLOUD_URL = 'https://united-goat-fjhnc2dscahcbyec.centralindia-01.azurewebsites.net';
const webUrl = window.location.hostname === 'localhost' ? 'http://localhost:3001' : '';

// The `android:local` script sets REACT_APP_BACKEND_LOCAL=true to point the app at
// a backend running on the dev machine instead of the cloud. With `--live-reload`
// the webview is served from the dev machine's IP, so reuse that host for the API
// (port 3001). If we can't read a usable host (e.g. a non-live-reload build serving
// from localhost), fall back to 10.0.2.2 — the Android emulator's alias for the host.
const useLocalBackend = process.env.REACT_APP_BACKEND_LOCAL === 'true';

const localMobileUrl = (): string => {
  const host = window.location.hostname;
  const apiHost = !host || host === 'localhost' ? '10.0.2.2' : host;
  return `http://${apiHost}:3001`;
};

let backendUrl: string;
if (isMobile) {
  backendUrl = useLocalBackend ? localMobileUrl() : CLOUD_URL;
} else {
  backendUrl = webUrl;
}

export default backendUrl;
